import Accounts from "../views/accounts";
import Overview from "../views/overview";
import Sites from "../views/sites";
import Applications from "../views/applications";
import App360 from "../views/app360";
import Circuits from "../views/circuits";
import Circuit360 from "../views/circuit360";
import PredictiveNetworks from "../views/insights";
import PNApplicationInfoAtSite
  from "../views/insightsApplicationInfo/applicationInfoPerSingleSiteView";
import PNApplicationInfoPathMetric
  from "../views/insightsApplicationInfo/pathMetricView";
import ADSites
  from "../views/insights/PredictiveWidgetTop/AnomalyDetection";
import ADSingleSite
  from "../views/insights/PredictiveWidgetTop/AnomalyDetection/ADSingleSite";
import SingleSiteTrend
  from "../views/insights/PredictiveWidgetTop/AnomalyDetection/ADSingleSiteTrend";
import ThreatIntelligence from "../views/security";
import Logs from "../views/logs";
import Optimization from "../views/optimization";
import AppQoeDetails from "../views/optimization/SingleSiteView/AppQoeDetails";
import Reports from "../views/reports/reportsTabListView";
import ReportOverview from "../views/reports/reportTemplates/executiveSummary/reportConfig";
import ReportSites from "../views/reports/reportTemplates/siteSummary/reportConfig";
import ReportApps from "../views/reports/reportTemplates/applicationSummary/reportConfig";
import ReportApp360 from "../views/reports/reportTemplates/app360Summary/reportConfig";
import { FEATURE_CONFIG, features, routeURLs } from "../utils/enums";
import ReportLinkSLA from "../views/reports/reportTemplates/linkSLA/reportConfig";
import ReportLinkUtilization from "../views/reports/reportTemplates/linkUtilization/reportConfig";
import ReportLinkAvailability from "../views/reports/reportTemplates/linkAvailability/reportConfig";
import ReportTopClients from "../views/reports/reportTemplates/topClientsReport/reportConfig";
import i18next from 'i18next';

// Helper function to get translations using global i18next from config namespace
const tConfig = (key, defaultValue = '') => {
  try {
    // Use config namespace for route-related translations
    return i18next.isInitialized ? i18next.t(key, { ns: 'config', defaultValue }) : defaultValue;
  } catch (error) {
    console.warn(`Translation key "${key}" not found in config namespace`);
    return defaultValue;
  }
};
/* Routes object with reactive translations using getters
 * access - authorization - default value true
 * access - admin - default value false
 * access - sidebar - default value true
*/
export const routes = {
  // landing page
  login: { module: null, access: { authorization: false, sidebar: false } },
  // landing page
  accounts: {
    module: Accounts,
    access: { authorization: false, sidebar: false }
  },
  // home dashboard
  overview: {
    get label() { return tConfig('tabConfigOverview'); },
    module: Overview
  },
  // sites dashboard
  sites: {
    get label() { return tConfig('tabConfigSites'); },
    module: Sites
  },
  // applications dashboard
  applications: {
    get label() { return tConfig('tabConfigApplications'); },
    module: Applications
  },
  app360: { module: App360 },
  // circuit
  circuits: {
    get label() { return tConfig('tabNavigationCircuits'); },
    module: Circuits
  },
  circuit360: { module: Circuit360 },
  // predictive networks
  pn: {
    get label() { return tConfig('tabConfigPredictiveNetworks'); },
    module: PredictiveNetworks,
    features:[features.ad,features.ppr, features.bwf]
  },
  bwf: {
    get label() { return tConfig('tabConfigPredictiveNetworks'); },
    module: PredictiveNetworks,
    features: [features.bwf]
  },
  appInfoAtSite: { module: PNApplicationInfoAtSite, features:[ features.ppr] },
  appInfoPathMetric: { module: PNApplicationInfoPathMetric, features:[features.ppr] },
  ad: { 
    get label() { return tConfig('anomalyLables.anomalyDetection'); }, 
    module: ADSites, 
    features: [features.ad], 
    beta: true 
  },
  adNew: {
    get label() { return tConfig('tabConfigPredictiveNetworks'); },
    module: ADSites,
    features: [features.ad],
    beta: true
  },
  adSingleSite: { get label() { return tConfig('adSingleSite'); }, module: ADSingleSite, features: [features.ad], beta: true },
  adSingleSiteTrend: { get label() { return tConfig('singleSiteTrend'); }, module: SingleSiteTrend, features: [features.ad], beta: true },
  // threat intelligence aka security
  threatIntelligence: {
    get label() { return tConfig('tabConfigSecurity'); },
    module: ThreatIntelligence,
    features: [features.ti]
  },
  //traffic logs
  trafficLogs: {
    get label() { return tConfig('tabLogs'); },
    module: Logs,
    features: [features.logs],
    beta: FEATURE_CONFIG.LOGS.isBeta
  },
  //Optimization
  optimization: {
    get label() { return tConfig('tabOptimization'); },
    module: Optimization,
    features: [features.appqoe],
    beta: true
  },
  // Optimization app qoe details
  appQoeDetails: { module: AppQoeDetails },
  // reports
  reports: { module: Reports, access: { admin: true } },
  // pdf reports
  reportOverview: { module: ReportOverview, access: { sidebar: false } },
  reportSites: { module: ReportSites, access: { sidebar: false } },
  reportApps: { module: ReportApps, access: { sidebar: false } },
  reportApp360: { module: ReportApp360, access: { sidebar: false } },
  reportLinkSLA: { module: ReportLinkSLA, access: { sidebar: false } },
  reportLinkUtilization: { module: ReportLinkUtilization, access: { sidebar: false } },
  reportLinkAvailability: { module: ReportLinkAvailability, access: { sidebar: false } },
  reportTopClients: { module: ReportTopClients, access: { sidebar: false } },
};

for (const key in routes) {
  const route = routes[key];
  route.path = routeURLs[key];
  const access = { authorization: true, admin: false, sidebar: true };
  route.access = Object.assign(access, route.access);
  route.id = key;
  if (Array.isArray(route.features) === false) route.features = [];
}

const modules = Object.values(routes).map(item => ({ ...item })).slice(1);

for (const key in routes) delete routes[key].module;

export { modules };

export const sidebarMenuItems = [
  {
    get text() { return tConfig('analyticsTitle'); },
    icon: "nav-insight",
    path: `/`,
    submenu: [
      routes.overview,
      routes.sites,
      routes.applications,
      routes.circuits,
      routes.adNew,
      routes.threatIntelligence,
      routes.trafficLogs,
      routes.optimization
    ]
  },
  {
    get text() { return tConfig('navConfigReportsLabel'); },
    icon: "nav-servers",
    path: `/`,
    submenu: [
      {
        ...routes.reports,
        get label() { return tConfig('reportGeneratedReports'); },
        feature: "reports",
        path: `${routes.reports.path}#generated-reports`
      },
      {
        ...routes.reports,
        get label() { return tConfig('reportReportTemplates'); },
        feature: "reports",
        path: `${routes.reports.path}#report-templates`
      }
    ]
  },
  {
    get text() { return tConfig('navConfigCiscoSDWANCenter'); },
    icon: "arrow-square-out",
    path: "",
    isVManageMenuItem: true,
    submenu: [{
      get text() { return tConfig('navConfigCiscoSDWANCenter'); }
    }]
  }
];

export const mainTabs = [
  routes.overview,
  routes.sites,
  routes.applications,
  routes.circuits,
  routes.pn,
  routes.threatIntelligence,
  routes.trafficLogs,
  routes.optimization
];

export const vManageTabsConfig = {
  overview: {
    get label() { return tConfig('vManageTabs.overview'); },
    url: "/overview"
  },
  devices: {
    get label() { return tConfig('vManageTabs.devices'); },
    url: "/devices"
  },
  security: {
    get label() { return tConfig('vManageTabs.security'); },
    url: "/security"
  },
  multicloud: {
    get label() { return tConfig('vManageTabs.multicloud'); },
    url: "/multicloud"
  },
  tunnels: {
    get label() { return tConfig('vManageTabs.tunnels'); },
    url: "/tunnels"
  },
  logs: {
    get label() { return tConfig('vManageTabs.logs'); },
    url: "/logs"
  },
  energyMangement: {
    get label() { return tConfig('vManageTabs.energyMangement'); },
    url: "/sustainability"
  },
  applications: routes.applications,
  sites: routes.sites,
  circuits: routes.circuits
};

export default modules;
